import { render, staticRenderFns } from "./userRegister.vue?vue&type=template&id=6dfc8e4c&scoped=true&"
import script from "./userRegister.vue?vue&type=script&lang=js&"
export * from "./userRegister.vue?vue&type=script&lang=js&"
import style0 from "./userRegister.vue?vue&type=style&index=0&id=6dfc8e4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfc8e4c",
  null
  
)

export default component.exports